'use client'

import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import Slideout from "@/components/slideout/Slideout"
import StackedPanel from "@/components/panel/StackedPanel"
import PanelHeader from "@/components/panel/PanelHeader"
import Button from "@/components/button/Button"
import Icon from "@/components/icon/Icon"
import PanelBody from "@/components/panel/PanelBody"
import LeadForm from "./LeadForm"
import PanelTitle from "@/components/panel/PanelTitle"
import useEventListener, { emitEvent } from "@/components/plugins/EventListener"
import PanelFooter from "@/components/panel/PanelFooter"
import Disclaimer from "@/components/panel/Disclaimer"
import { strings } from "@/utils/I18n"
import ApiUtils from "@/utils/ApiUtils"

const LeadFormSlide = forwardRef((props, ref) => {
  
  const slide = useRef()
  const [customerId, setCustomerId] = useState(props.site?.session?.lead?.customer_id)
  const [data,setData] = useState({})
  const [isLeadFormOpened, setIsLeadFormOpened] = useState(false)
  const [leadSubmited, setLeadSubmited] = useState(props.site?.session?.lead?.customer_id != null)
  
  useEventListener("show_lead_form_slide", event => {
    setIsLeadFormOpened(!isLeadFormOpened)
    slide.current.toggle()
    setData(event.detail || {})
  })
  
  useEventListener("lead_submitted", event => {
    if (event.detail?.customer_id) {
      setLeadSubmited(true)
      setCustomerId(event.detail?.customer_id)
    }
    if (event.detail?.lead?.customer_id) {
      setLeadSubmited(true)
      setCustomerId(event.detail?.lead?.customer_id)
    }
  })
  
  useEventListener("lead_sync_request", event => {
    if (customerId) emitEvent("lead_sync", { customer_id: customerId })
  })

  useEventListener("visitor_viewed", event => {
    if (!props.site?.lead?.customer_id && event.detail.lead?.customer_id) {
      emitEvent("lead_submitted", event.detail)
    }
  })

  useEventListener("customer_create_or_update", event => {
    if (event.detail?.customer_id) {
      ApiUtils.postRequest("/api/visitor/track", { 
        payload: { 
          lead: { 
            customer_id: event.detail.customer_id,
          }
        } 
      })
    }
  })
  
  useEffect(() => {
    if (props.showLeadFormSlide) toggle()
  }, [props.showLeadFormSlide])
  
  const toggle = () => {
    setIsLeadFormOpened(!isLeadFormOpened)
    slide.current.toggle()
  }

  const onSubmit = () => {
    setLeadSubmited(true)
  }
  
  useImperativeHandle(ref, () => ({
    toggle
  }))
  
  return <Slideout ref={slide} style={{width: '480px'}}>
    <StackedPanel>
      <PanelHeader>
        <PanelTitle centered={true} leftPad={true}>
          <h2>{ leadSubmited ? 'Thank You' : 'Contact Us to Get Started' }</h2>
        </PanelTitle>
        <div>
          <Button theme={'icon'} onClick={e => toggle(e)} label={ 'Close' }>
            <span className="ico-smaller"><Icon {...props} name="x"></Icon></span>
          </Button>
        </div>        
      </PanelHeader>
      <PanelBody padded={true}>
        { leadSubmited &&
        <section>
          { strings(props.site)['vdp_leadReceivedMessage'] }
        </section>
        }
        { leadSubmited &&
        <section>
          <Button theme={['line','inline']} onClick={e => toggle(e)}>Close</Button>
        </section>
        }
        { !leadSubmited &&
        <section>
          <LeadForm {...props} ctx={'slide'} isLeadFormOpened={isLeadFormOpened} onSubmit={() => onSubmit()}></LeadForm>
        </section>
        }
        { !leadSubmited &&
        <section>
          <Disclaimer disclaimer={ props?.site?.lead?.disclaimer }></Disclaimer>
        </section>
        }
      </PanelBody>
      <PanelFooter className={'flex-with-gap'}>
        <div><Button theme="plain" label="Privacy" href="/privacy"><span className="text-sm">Privacy</span></Button></div>
        <div><Button theme="plain" label="Terms of Service" href="/terms"><span className="text-sm">Terms of Service</span></Button></div>
      </PanelFooter>
    </StackedPanel>
  </Slideout>    

})

LeadFormSlide.displayName = 'LeadFormSlide';
export default LeadFormSlide